/* LEDPLANET - Toolmail + Delen, kern (17-10-2026). Hoort bij snippets/ledplanet-toolmail.liquid: daar staan de API-uitleg,
   de tag-opbouw, het formulier en de teksten in 7 talen. Koppelingen voor bestaande pagina's: assets/lp-toolmail-koppel.js,
   voor lamp-herkenner en lichtkleur: assets/lp-toolmail-tools.js. */
(function () {
  'use strict';
  var EUR = new RegExp(String.fromCharCode(8364), 'g');
  if (window.LPToolmail && window.LPToolmail.echt) return;
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('lp-tm-cfg').textContent); } catch (e) {}
  var T = CFG.t || {}, TAAL = CFG.taal || 'nl';
  var bron = document.getElementById('lp-tm');
  var form = bron ? bron.querySelector('form') : null;

  /* ---------- terugkomst na verzenden ---------- */
  var qs = new URLSearchParams(location.search);
  var POSTED = qs.get('lp_tm') === '1' && qs.get('customer_posted') === 'true';
  var FOUT = location.hash === '#lp-tm-form' || !!(bron && bron.querySelector('[data-tm-fout-server]'));
  if (qs.has('lp_tm')) {
    qs.delete('lp_tm'); qs.delete('customer_posted');
    var q2 = qs.toString();
    try { history.replaceState(history.state, '', location.pathname + (q2 ? '?' + q2 : '') + (location.hash === '#lp-tm' ? '' : location.hash)); } catch (e) {}
  }
  var gemeld = false;

  /* ---------- hulpjes ---------- */
  function val(x) { try { return typeof x === 'function' ? x() : x; } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function schoon(s) { return String(s == null ? '' : s).replace(EUR, '').replace(/\s+/g, ' ').trim(); }
  function regels(s) { return String(s == null ? '' : s).replace(EUR, '').replace(/\r/g, '').trim(); }
  function abs(u) { try { return new URL(u || location.href, location.href); } catch (e) { return new URL(location.href); } }
  var WEG = ['preview_theme_id', 'lp_tm', 'customer_posted', 'contact_posted', 'fbclid', 'gclid', '_pos', '_sid', '_ss', '_psq', '_v'];
  function netteLink(u) {
    var x = abs(u);
    if (WEG.some(function (k) { return x.searchParams.has(k); })) WEG.forEach(function (k) { x.searchParams.delete(k); });
    if (x.hash === '#lp-tm' || x.hash === '#lp-tm-form') x.hash = '';
    return x.toString();
  }
  function isPromise(v) { return v && typeof v.then === 'function'; }
  // link nu (synchroon): string of functie; bij een Promise de laatst opgehaalde waarde
  function linkNu(o) {
    var v = val(o.link);
    if (isPromise(v)) { v.then(function (s) { if (s) o._link = netteLink(s); }, function () {}); return o._link || netteLink(location.href); }
    return netteLink(v || location.href);
  }
  function linkLater(o) {
    var v = val(o.link);
    if (isPromise(v)) return v.then(function (s) { o._link = netteLink(s || location.href); return o._link; }, function () { return o._link || netteLink(location.href); });
    return Promise.resolve(netteLink(v || location.href));
  }
  function imgUrl(u) {
    if (!u) return '';
    u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u;
    try { var x = new URL(u, location.href); if (/cdn\.shopify\.com|\/cdn\/shop\//.test(x.href)) x.searchParams.set('width', '300'); return x.toString(); } catch (e) { return ''; }
  }
  function zet(el, o, blok) {
    var p = o.plaats || 'in';
    if (p === 'na') { if (el.nextSibling !== blok) el.parentNode.insertBefore(blok, el.nextSibling); }
    else if (p === 'voor') { if (el.previousSibling !== blok) el.parentNode.insertBefore(blok, el); }
    else if (blok.parentNode !== el) el.appendChild(blok);
  }

  /* ---------- delen ---------- */
  var IC = {
    kopie: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 10a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>',
    wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#25D366" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2z"/><path fill="#fff" d="M17.2 14.4c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.6.1l-.9 1.1c-.2.2-.3.2-.6.1a7.6 7.6 0 0 1-3.8-3.3c-.3-.5.3-.5.8-1.6.1-.2 0-.4 0-.5l-.9-2c-.2-.6-.5-.5-.6-.5h-.5c-.2 0-.5.1-.7.3-.2.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 1.8.8 2.5.8 3.4.7.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>',
    native: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12M7 8l5-5 5 5"/><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>'
  };
  var kanNative = false;
  try { kanNative = !!navigator.share && !!(window.matchMedia && matchMedia('(pointer: coarse)').matches); } catch (e) {}

  function deelTeksten(o, link) {
    var titel = schoon(val(o.titel)) || schoon(document.title);
    var tekst = regels(val(o.deelTekst || o.tekst)) || titel;
    return {
      titel: titel, tekst: tekst, link: link,
      wa: 'https://wa.me/?text=' + encodeURIComponent(tekst + '\n' + link),
      mail: 'mailto:?subject=' + encodeURIComponent(titel) + '&body=' + encodeURIComponent(tekst + '\n\n' + link)
    };
  }
  function deelRij(o) {
    var d = document.createElement('div');
    d.className = 'lp-tm__deel';
    d.innerHTML = '<span class="lp-tm__dl">' + esc(T.delen || 'Delen') + '</span>' +
      '<button type="button" class="lp-tm__k" data-d="kopie">' + IC.kopie + esc(T.kopie || 'Link kopiëren') + '</button>' +
      '<a class="lp-tm__k" data-d="wa" href="https://wa.me/" target="_blank" rel="noopener">' + IC.wa + esc(T.wa || 'WhatsApp') + '</a>' +
      '<a class="lp-tm__k" data-d="mail" href="mailto:">' + IC.mail + esc(T.mail || 'E-mail') + '</a>' +
      (kanNative ? '<button type="button" class="lp-tm__k" data-d="native">' + IC.native + esc(T.native || 'Delen…') + '</button>' : '') +
      '<span class="lp-tm__gek" role="status" aria-live="polite" hidden>✓ ' + esc(T.gekopieerd || 'Gekopieerd') + '</span>';
    var gek = d.querySelector('.lp-tm__gek'), tijd;
    function doe(soort, link, b, laat) {
      var x = deelTeksten(o, link);
      if (soort === 'kopie') {
        var klaar = function () { gek.hidden = false; clearTimeout(tijd); tijd = setTimeout(function () { gek.hidden = true; }, 2500); };
        var p = navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(link) : Promise.reject();
        p.then(klaar, function () { window.prompt(T.prompt || 'Kopieer deze link:', link); });
        try { var a = abs(link); if (a.origin === location.origin && a.pathname === location.pathname) history.replaceState(history.state, '', a.pathname + a.search + a.hash); } catch (e) {}
      } else if (soort === 'wa') {
        if (laat) { if (!window.open(x.wa, '_blank', 'noopener')) location.href = x.wa; } else b.href = x.wa;
      } else if (soort === 'mail') {
        if (laat) location.href = x.mail; else b.href = x.mail;
      } else if (soort === 'native') {
        try { navigator.share({ title: x.titel, text: x.tekst, url: link }).catch(function () {}); } catch (e) {}
      }
    }
    d.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-d]');
      if (!b) return;
      var soort = b.getAttribute('data-d'), v = val(o.link);
      if (isPromise(v)) {
        e.preventDefault();
        v.then(function (s) { o._link = netteLink(s || location.href); doe(soort, o._link, b, true); }, function () { doe(soort, netteLink(location.href), b, true); });
        return;
      }
      doe(soort, netteLink(v || location.href), b, false);
    });
    var vooraf = function () { if (isPromise(val(o.link))) linkLater(o); };
    d.addEventListener('pointerenter', vooraf); d.addEventListener('focusin', vooraf);
    return d;
  }
  function delenMount(el, o) {
    if (typeof el === 'string') el = document.querySelector(el);
    o = o || {};
    if (!el || !el.parentNode && o.plaats && o.plaats !== 'in') return null;
    var blok = o._blok;
    if (!blok) {
      blok = document.createElement('div');
      blok.className = 'lp-tm lp-tm--deel' + (o.klein ? ' lp-tm--klein' : '');
      blok.appendChild(deelRij(o));
      o._blok = blok;
    }
    zet(el, o, blok);
    return blok;
  }

  /* ---------- mailblok ---------- */
  var huidig = null;
  function toonStatus(blok) {
    if (gemeld || !blok) return;
    if (POSTED) {
      gemeld = true;
      form.hidden = true;
      bron.querySelector('[data-tm-ok]').hidden = false;
      setTimeout(function () { blok.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 1500);
    } else if (FOUT) {
      gemeld = true;
      var f = bron.querySelector('[data-tm-fout]'); f.hidden = false;
      setTimeout(function () { blok.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 1500);
    }
  }
  function mount(el, o) {
    if (typeof el === 'string') el = document.querySelector(el);
    o = o || {};
    if (!el) return null;
    if (o.mail === false || !form) return o.delen === false ? null : delenMount(el, o);
    huidig = { el: el, o: o };
    bron.querySelector('[data-tm-kop]').textContent = o.kop || T['kop_' + o.soort] || T.kop || 'Mail mij dit resultaat';
    bron.querySelector('[data-tm-uitleg]').textContent = (o.extra ? o.extra + ' ' : '') + (T.uitleg || '');
    var oud = bron.querySelector('.lp-tm__deel');
    if (oud) oud.parentNode.removeChild(oud);
    if (o.delen !== false) bron.appendChild(deelRij(o));
    zet(el, o, bron);
    toonStatus(bron);
    if (isPromise(val(o.link))) linkLater(o);
    return bron;
  }
  function tagsVoor(o, link) {
    var run = String(Math.floor(Date.now() / 1000)), p = 'tm-' + run + '-';
    var tool = schoon(val(o.tool) || CFG.pagina || CFG.type || 'tool').toLowerCase().replace(/[^a-z0-9-]+/g, '-').slice(0, 40);
    var tags = ['toolmail', 'tm-run:' + run, p + 'tool:' + tool, p + 'taal:' + TAAL];
    tags.push(p + 'titel:' + (schoon(val(o.titel)) || schoon(document.title)).slice(0, 200));
    var l = String(link).replace(/,/g, '%2C');
    if (l.length > 16 * 230) l = netteLink(location.origin + location.pathname);
    for (var i = 0, n = 1; i < l.length && n <= 16; i += 230, n++) tags.push(p + 'l' + n + ':' + l.slice(i, i + 230));
    (val(o.samenvatting) || []).map(schoon).filter(Boolean).slice(0, 8).forEach(function (s, j) { tags.push(p + 's' + (j + 1) + ':' + s.slice(0, 220)); });
    var k = 0;
    (val(o.producten) || []).forEach(function (x) {
      if (!x || k >= 6) return;
      var h = x.handle || (String(x.url || x.u || '').match(/\/products\/([^/?#]+)/) || [])[1];
      if (!h) return;
      k++;
      tags.push(p + 'p' + k + ':' + h.slice(0, 220));
      tags.push(p + 'pt' + k + ':' + (schoon(x.titel || x.t).replace(/\|/g, '/').slice(0, 170) + '|' + schoon(x.prijs || x.pr)).slice(0, 220));
      var im = imgUrl(x.img);
      if (im && im.length <= 225) tags.push(p + 'pi' + k + ':' + im);
    });
    return tags.map(function (t) { return t.replace(/,/g, ';').slice(0, 250); });
  }
  if (form) {
    form.querySelector('[data-tm-email]').placeholder = T.email || 'E-mailadres';
    form.querySelector('[data-tm-email]').setAttribute('aria-label', T.email || 'E-mailadres');
    form.querySelector('[data-tm-knop]').textContent = T.knop || 'Mail mij';
    bron.querySelector('[data-tm-fout]').textContent = T.fout || '';
    bron.querySelector('[data-tm-oktekst]').textContent = T.ok || '';
    form.addEventListener('focusin', function () { if (huidig && isPromise(val(huidig.o.link))) linkLater(huidig.o); });
    form.addEventListener('submit', function () {
      var o = huidig ? huidig.o : {}, link = linkNu(o);
      form.querySelector('[data-tm-tags]').value = tagsVoor(o, link).join(', ');
      var a = abs(link), t = a.origin === location.origin ? a : abs(location.href), sp = new URLSearchParams(t.search);
      WEG.forEach(function (x) { sp.delete(x); });
      sp.set('lp_tm', '1'); sp.set('customer_posted', 'true');
      form.querySelector('[data-tm-terug]').value = t.pathname + '?' + sp.toString() + (t.hash && t.hash.length > 1 && t.hash !== '#lp-tm-form' ? t.hash : '#lp-tm');
      try { localStorage.setItem('lp_popup_done', '1'); } catch (e) {}
    });
  }
  // geen tool die het blok toont (bijv. uitkomst niet hersteld)? Dan toch een nette bevestiging.
  if (POSTED || FOUT) setTimeout(function () {
    if (gemeld) return;
    gemeld = true;
    var d = document.createElement('div');
    d.className = 'lp-tm lp-tm-toast';
    d.setAttribute('role', 'status');
    d.innerHTML = POSTED ? '<p class="lp-tm__ok">' + esc(T.ok) + '<br><span class="lp-tm__bas">Bas / LEDPLANET.NL</span></p>' : '<p class="lp-tm__fout" style="margin:0">' + esc(T.fout) + '</p>';
    var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', T.sluit || 'Sluiten'); x.textContent = '×';
    x.addEventListener('click', function () { d.remove(); });
    d.appendChild(x); document.body.appendChild(d);
    setTimeout(function () { if (d.parentNode) d.remove(); }, 12000);
  }, 5000);

  /* ---------- API + wachtrij ---------- */
  var api = {
    echt: true,
    mount: mount,
    update: function (o) { if (!huidig) return null; for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) huidig.o[k] = o[k]; return mount(huidig.el, huidig.o); },
    tags: function (o) { o = o || (huidig && huidig.o) || {}; return tagsVoor(o, linkNu(o)); },
    link: function () { return huidig ? linkNu(huidig.o) : netteLink(location.href); }
  };
  var delen = { echt: true, mount: delenMount };
  var q1 = window.LPToolmailQ || [], q2b = window.LPDelenQ || [];
  window.LPToolmail = api; window.LPDelen = delen;
  window.LPToolmailQ = { push: function (a) { if (a[2]) api.update(a[1]); else mount(a[0], a[1]); } };
  window.LPDelenQ = { push: function (a) { delenMount(a[0], a[1]); } };
  (q1.forEach ? q1 : []).forEach(function (a) { window.LPToolmailQ.push(a); });
  (q2b.forEach ? q2b : []).forEach(function (a) { window.LPDelenQ.push(a); });

})();